import '@muzly/shared/i18n';
// Before ./styles.css so the app's own rules can override the library defaults.
import '@lemoncloud/page-transition-core/styles.css';
import './styles.css';

import { StrictMode } from 'react';

import * as ReactDOM from 'react-dom/client';

import { App } from './app/app';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
